import withErrorCheck from "../CheckError";
import server from "../Server";

export type GetPlayerByIdPayload = { id: number };
export type PlayerMinimal = { id: number; name: string | null; profile_picture: string | null };

export const GetPlayerById = async ({ id }: GetPlayerByIdPayload): Promise<PlayerMinimal | null> => {
  const response = await server
    .from("Players")
    .select(["id", "name", "profile_picture"].join(","))
    .eq("id", id)
    .single();

  const player = withErrorCheck<PlayerMinimal | null>(response as any) || null;
  return player;
};
